import { defineComponent as _defineComponent } from 'vue'
import IModal from '@/js/components/molecules/IModal.vue';
import CartModal from './CartModal.vue';

import { addToBasket, removeFromBasket } from '@/js/lib/api/cart';
import { info } from '@/js/lib/ui';
import { mountModal } from '@/js/lib/ui/helper/dynamic-modal';
import { useCommonStore } from '@/js/lib/store/common';
import { useCartStore } from '@/js/lib/store/cart';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlreadyInCartModal',
  props: {
    itemId: null,
    itemOptionVariantSlugs: null
  },
  setup(__props: any) {

const props = __props as {
  itemId: number;
  itemOptionVariantSlugs: string[];
};

const { isWebView } = useCommonStore();
const cartStore = useCartStore();



const replaceItemOption = async () => {
  try {
    await removeFromBasket({ itemId: props.itemId });
    await addToBasket({ itemId: props.itemId, itemOptionVariantSlugs: props.itemOptionVariantSlugs });

    // 以前のeコマースオブジェクトをクリアする
    // eslint-disable-next-line unicorn/no-null
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_id: props.itemId,
            quantity: 1,
          },
        ],
      },
    });

    if (isWebView) {
      info('カートの内容を変更しました', { fadeOut: true });
      return;
    }
    await cartStore.loadBaskets();
    mountModal({
      Component: CartModal,
      props: {
        text: 'カートの内容を変更しました',
      },
    });
  } catch (error) {
    if (error?.response?.data?.errors.includes('stock_missing')) {
      info('注文個数が在庫数を超えています。');
    } else {
      info('カートの内容を変更できませんでした。');
    }
  }
};

return { __sfc: true,isWebView, cartStore, props, replaceItemOption, IModal }
}

})